import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

// 引入 Tailwind CSS
import '@/assets/tailwind.css';

// 完整导入 UI 组件库
import VxeUI from 'vxe-pc-ui';
import 'vxe-pc-ui/lib/style.css';

// 完整导入 表格库
import VxeUITable from 'vxe-table';
import 'vxe-table/lib/style.css';

Vue.use(VxeUI);
Vue.use(VxeUITable);

import $http from '@/utils/axios';
import $strings from '@/utils/strings';
import $dates from '@/utils/dates';
import { hasPermission, isSuperAdmin, isTenantAdmin } from '@/common/permission';
import type { UserProfile } from '@/types/user';

Vue.prototype.$http = $http;
Vue.prototype.$strings = $strings;
Vue.prototype.$dates = $dates;
Vue.prototype.$hasPermission = function (this: any, code: string) {
  return hasPermission(this.$store?.state?.user, code);
};
/** 判断当前登录用户（或指定用户对象）是否为超级管理员（username === 'admin'），模板可用 v-if="$isSuperAdmin()" */
Vue.prototype.$isSuperAdmin = function (this: any, targetUser?: UserProfile | null) {
  return isSuperAdmin(targetUser || this.$store?.state?.user);
};
/** 判断是否属于租户管理员（角色为 tenantAdmin），模板可用 v-if="$isTenantAdmin()" */
Vue.prototype.$isTenantAdmin = function (this: any, targetUser?: UserProfile | null, tenantCode?: string) {
  return isTenantAdmin(targetUser || this.$store?.state?.user, tenantCode);
};

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// 注册全局图标组件 XIcon
import XIcon from '@/components/XIcon/index.vue';
Vue.component('XIcon', XIcon);

// 注册全局 Markdown 预览组件
import XMarkdownViewer from '@/components/x-markdown-viewer/index.vue';
Vue.component('XMarkdownViewer', XMarkdownViewer);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
